import { z } from 'zod';

/////////////////////////////////////////
// PERMITS WAIVE FEES SCHEMA
/////////////////////////////////////////

export const PermitsWaiveFeesSchema = z.object({
  id: z.bigint(),
  amount: z.number().int().nullable(),
  note: z.string().nullable(),
  permit_id: z.bigint(),
  created_at: z.coerce.date(),
  updated_at: z.coerce.date(),
  fee_id: z.bigint().nullable(),
  permits_extension_id: z.bigint().nullable(),
  fee_item_id: z.bigint().nullable(),
  rowTimestamp: z.coerce.date(),
})

export type PermitsWaiveFees = z.infer<typeof PermitsWaiveFeesSchema>

export default PermitsWaiveFeesSchema;
